import Modal from "./Modal";

const Confirmation = ({ open, setOpen, title, description, success }) => {
  return (
    <Modal open={open} setOpen={setOpen} title={title} confirm={success}>
      <span>{description}</span>
    </Modal>
  );
};

export default Confirmation;
